import TabContentTemplate from './TabContentTemplate';
export default TabContentTemplate;